webpackJsonp([12633738913030],{

/***/ 1414:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"ID","kind":"SCALAR","type":"OBJECT","fields":null,"description":"The `ID` scalar type represents a unique identifier, often used to\nrefetch an object or as key for a cache. The ID type appears in a JSON\nresponse as a String; however, it is not intended to be human-readable.\nWhen expected as an input type, any string (such as `\"4\"`) or integer\n(such as `4`) input value will be accepted as an ID.","enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---scalar-id-ca82b493ea8487e85165.js